import React, { ReactNode, useState } from 'react';
import ThemeWrapper from '../../components/SharedThemeWrapper/ThemeWrapper';
import { CloseButton, Description, MainContainer, MoreDetails, NotificationOverrides, Title } from './style';

import { FormattedMessage } from 'react-intl';
import CloseIconBlack from '../../assets/img/close-icon-black.svg';
import CloseIconWhite from '../../assets/img/close-icon-white.svg';
import WarningIcon from '../../assets/img/info-black.svg';
import SuccessIcon from '../../assets/img/success-tick.svg';
import InfoIcon from '../../assets/img/warning.svg';
import { NotificationType } from './types';

const getIconByType = (type: NotificationType): string => {
  switch (type) {
    case 'success':
      return SuccessIcon;
    case 'warning':
      return WarningIcon;
    case 'error':
    case 'info':
    case 'default':
    default:
      return InfoIcon;
  }
};

const mapMessageTypeToLocalization = {
  success: { id: 'toaster.success', defaultMessage: 'Success' },
  warning: { id: 'toaster.warning', defaultMessage: 'Warning' },
  error: { id: 'toaster.error', defaultMessage: 'Error' },
  info: { id: 'toaster.info', defaultMessage: 'Info' },
  default: { id: 'toaster.info', defaultMessage: 'Info' },
};
interface ToastMessageProps {
  message: string | ReactNode;
  closeToast: () => void;
  type: NotificationType;
}

const ToastMessage: React.FC<ToastMessageProps> = ({ type, message, closeToast }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const charLimit = 120;
  const isWarning = type === 'warning';
  const icon = getIconByType(type);

  const isStringMessage = typeof message === 'string';
  const messageLength = isStringMessage ? (message as string).length : charLimit + 1;
  const isLongStringMessage = isStringMessage && messageLength > charLimit;
  const displayMessage = isLongStringMessage
    ? isExpanded
      ? message
      : (message as string).substring(0, charLimit) + '... '
    : message;

  return (
    <ThemeWrapper>
      <NotificationOverrides />
      <MainContainer type={type}>
        <CloseButton onClick={closeToast}>
          <img src={isWarning ? CloseIconBlack : CloseIconWhite} alt="close" />
        </CloseButton>
        <Title color={isWarning ? 'black' : 'white'}>
          <img src={icon} alt={`${type} icon`} />
          <span>
            <FormattedMessage
              id={mapMessageTypeToLocalization[type]?.id || 'toaster.info'}
              defaultMessage={mapMessageTypeToLocalization[type]?.defaultMessage || 'Info'}
            />
          </span>
        </Title>
        <Description color={isWarning ? 'black' : 'white'}>{displayMessage}</Description>
        <MoreDetails
          color={isWarning ? 'black' : 'white'}
          onClick={e => {
            if (isLongStringMessage) {
              e.stopPropagation();
              setIsExpanded(!isExpanded);
            } else {
              closeToast();
            }
          }}
        >
          {isLongStringMessage ? (
            isExpanded ? (
              <FormattedMessage id="toaster.less" defaultMessage="Show less" />
            ) : (
              <FormattedMessage id="toaster.more" defaultMessage="Show more" />
            )
          ) : (
            <FormattedMessage id="toaster.ok" defaultMessage="OK" />
          )}
        </MoreDetails>
      </MainContainer>
    </ThemeWrapper>
  );
};

export default ToastMessage;
